export default __webpack_public_path__ + "static/media/calendar.0f63587c.svg";